export default {
  landing: 'next_button',
  questions: 'submit_button',
};
